import { CalendarSlotForm, CalendarSlotDeleteForm } from '.'
import { ApiService } from '~/shared/api'
import { restCreate, restGetItem, restGetList, restUpdate, sendForm } from '~/shared/utils/decorators'
import type {
  ServiceCanSendForm,
  ServiceRestCreate,
  ServiceRestGetItem,
  ServiceRestGetList,
  ServiceRestUpdate
} from '~/shared/interfaces'
import { toModel, toModels } from '~/shared/api/utils'
import { CalendarSlotModel } from '~/model/Calendars'
import type { CalendarsSlotsListParams } from '~/interfaces/Calendars'

// eslint-disable-next-line
interface SlotsService extends ServiceRestCreate, ServiceCanSendForm, ServiceRestUpdate, ServiceRestGetItem, ServiceRestGetList {}

@sendForm
@restCreate
@restUpdate
@restGetItem
@restGetList
// eslint-disable-next-line no-redeclare
class SlotsService extends ApiService {
  protected route: string = 'calendars/slots'

  getListModel(params: CalendarsSlotsListParams = {}): Promise<Array<CalendarSlotModel>> {
    return this.getList(params).then(toModels(CalendarSlotModel))
  }

  getItemModel(id: string): Promise<CalendarSlotModel> {
    return this.getItem(id).then(toModel(CalendarSlotModel))
  }

  createModel(form: CalendarSlotForm): Promise<CalendarSlotModel> {
    return this.create(form.setSendAs('form-data')).then(toModel(CalendarSlotModel))
  }

  updateModel(id: string, form: CalendarSlotForm): Promise<CalendarSlotModel> {
    return this.update(id, form.setSendAs('form-data')).then(toModel(CalendarSlotModel))
  }

  delete(id: string, form: CalendarSlotDeleteForm) {
    return this.sendForm(form, `${this.prefix}/${this.route}/${id}`)
  }
}

export default SlotsService
